export const getFileExtension = (file: File) => file.name.split('.').pop()

export const downloadFile = (blob: Blob | string, fileName: string) => {
  const href = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('download', fileName)
  link.setAttribute('href', href)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadFileFromLink = (href: string) => {
  const link = document.createElement('a')
  const fileName = href.split('/').pop() || ''
  link.setAttribute('download', fileName)
  link.setAttribute('href', href)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
